import { Box, makeStyles, Theme } from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import QuoteTopPriceOptions from "./QuoteTopPriceOptions";
import { QuoteHr } from "./QuoteHr";
import { EventSlot } from "../../../api/EventSlot/EventSlot";
import EventAvailableIcon from "@material-ui/icons/EventAvailable";
import { format } from "date-fns";
import { DeductionApply } from "../../../components/deduction/DeductionApply";
import { DeductionLines } from "../../../components/deduction/DeductionLines";
import { TF } from "../../../components/typography/TF";

interface Props {
  quote: Quote;
  selectedEventSlot?: EventSlot | null;
  onApplyPromoCode: (promoCode: string) => void;
  onDeletePromoCode: (quoteDeductionId: string) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    verticalAlign: "text-top",
    marginRight: theme.spacing(1)
  }
}));

const QuoteRightInfo = ({ quote, selectedEventSlot, onApplyPromoCode, onDeletePromoCode }: Props) => {
  const classes = useStyles();

  const summarySection = (
    <>
      <TF variant="h2" color="darkGrey">
        Summary
      </TF>
      <Box mt={2} display="flex" alignItems="center">
        <Box flexGrow={1}>
          <TF variant="body2" color="storeGrey">
            Your price including installation
          </TF>
        </Box>
        <Box textAlign="center" pr={6}>
          <TF variant="h2" bold format="price" color="darkGrey">
            {quote.price}
          </TF>
          <TF variant="caption">Inc VAT</TF>
        </Box>
      </Box>
    </>
  );

  const subTotalSection = (
    <>
      <Box display="flex" alignItems="center">
        <Box flexGrow={1}>
          <TF variant="body2" color="storeGrey">
            Subtotal
          </TF>
        </Box>
        <Box pr={6}>
          <TF variant="h4" color="storeGrey" format="price">
            {quote.fullPrice}
          </TF>
        </Box>
      </Box>
    </>
  );

  const totalSection = (
    <>
      <Box display="flex" alignItems="center">
        <Box flexGrow={1}>
          <TF variant="h4" color="darkGrey">
            Total (inc VAT)
          </TF>
        </Box>
        <Box pr={6}>
          <TF variant="h2" bold format="price" color="darkGrey">
            {quote.price}
          </TF>
        </Box>
      </Box>
    </>
  );

  const slotSection = selectedEventSlot && (
    <>
      <QuoteHr mt={2} mb={2} />
      <Box display="flex" alignItems="center">
        <Box flexGrow={1}>
          <EventAvailableIcon className={classes.icon} color="secondary" />
          <TF variant="body2" component="span" color="storeGrey">
            Installation Date
          </TF>
        </Box>
        <Box>
          <TF variant="h3" bold component="span" color="darkGrey">
            {format(new Date(selectedEventSlot.startDate), "d")}&nbsp;
          </TF>
          <TF variant="h4" bold component="span" color="darkGrey">
            {format(new Date(selectedEventSlot.startDate), "MMM")}
          </TF>
        </Box>
      </Box>
    </>
  );

  return (
    <Box>
      <Box>{summarySection}</Box>
      <QuoteHr mt={2} mb={2} />
      <Box>
        <DeductionApply onApply={onApplyPromoCode} />
      </Box>
      <QuoteHr mt={2} mb={2} />
      <Box>{subTotalSection}</Box>
      <Box>
        <DeductionLines quote={quote} onDelete={onDeletePromoCode} />
      </Box>
      <Box>{totalSection}</Box>
      <Box mt={2}>
        <QuoteTopPriceOptions quote={quote} textAlign="left" />
      </Box>

      {slotSection}
    </Box>
  );
};

export default QuoteRightInfo;
